import http from '@/utils/ajax'
import { CLAIMPARAM_INIT_SUCCESS, CLAIMPARAM_INIT_LOADING, CLAIMPARAM_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

const getters = {

}

const mutations = {
  [CLAIMPARAM_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [CLAIMPARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [CLAIMPARAM_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}

const actions = {
  async claimParamManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.clmParamManagement
    commit(CLAIMPARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CLAIMPARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CLAIMPARAM_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
